export const OriginalReportRowsExampleJSON = {
  "rows": [
    {
      "rowNum": 1,
      "familyId": 100,
      "camperName": "JJC1",
      "camperAge": 7,
      "enrolledSessions": "Week 1, Week 2",
      "parent1Name": "John",
      "parent1Email": "john@test.com",
      "parent2Name": "Jill",
      "parent2Email": "jill@test.com"
    },
    {
      "rowNum": 2,
      "familyId": 100,
      "camperName": "JJC2",
      "camperAge": 10,
      "enrolledSessions": "Week 2, Week 3",
      "parent1Name": "John",
      "parent1Email": "john@test.com",
      "parent2Name": "Jill",
      "parent2Email": "jill@test.com"
    },
    {
      "rowNum": 3,
      "familyId": 100,
      "camperName": "JJC3",
      "camperAge": 12,
      "enrolledSessions": "Week 5",
      "parent1Name": "John",
      "parent1Email": "john@test.com",
      "parent2Name": "Jill",
      "parent2Email": "jill@test.com"
    },
    {
      "rowNum": 4,
      "familyId": 101,
      "camperName": "AAC1",
      "camperAge": 8,
      "enrolledSessions": "Week X",
      "parent1Name": "Andy",
      "parent1Email": "andy@test.com",
      "parent2Name": "Angela",
      "parent2Email": "angela@test.com"
    },
    {
      "rowNum": 5,
      "familyId": 101,
      "camperName": "AAC2",
      "camperAge": 10,
      "enrolledSessions": "Week Y",
      "parent1Name": "Andy",
      "parent1Email": "andy@test.com",
      "parent2Name": "Angela",
      "parent2Email": "angela@test.com"
    }
  ]
};

export const AfterGroupByTransformationExampleJSON = {
  "rows": [
    {
      "familyId": 100,
      "campers": [
        { "camperName": "JJC1", "camperAge": 7, "enrolledSessions": "Week 1, Week 2" },
        { "camperName": "JJC2", "camperAge": 10, "enrolledSessions": "Week 2, Week 3" },
        { "camperName": "JJC3", "camperAge": 12, "enrolledSessions": "Week 5" }
      ],
      "parents": [
        {
          "rowNum": 1,
          "parent1Name": "John1",
          "parent1Email": "john@test.com",
          "parent2Name": "Jill",
          "parent2Email": "jill@test.com"
        },
        {
          "rowNum": 2,
          "parent1Name": "John2",
          "parent1Email": "john@test.com",
          "parent2Name": "Jill",
          "parent2Email": "jill@test.com"
        },
        {
          "rowNum": 3,
          "parent1Name": "John",
          "parent1Email": "john@test.com",
          "parent2Name": "Jill",
          "parent2Email": "jill@test.com"
        }
      ]
    },
    {
      "familyId": 101,
      "campers": [
        { "camperName": "AAC1", "camperAge": 8, "enrolledSessions": "Week X" },
        { "camperName": "AAC2", "camperAge": 10, "enrolledSessions": "Week Y" }
      ],
      "parents": [
        {
          "rowNum": 4,
          "parent1Name": "Andy",
          "parent1Email": "andy@test.com",
          "parent2Name": "Angela",
          "parent2Email": "angela@test.com"
        },
        {
          "rowNum": 5,
          "parent1Name": "Andy",
          "parent1Email": "andy@test.com",
          "parent2Name": "Angela",
          "parent2Email": "angela@test.com"
        }
      ]
    }
  ]
}

export const AfterMapObjectTransformationExampleRows = {
  "rows": [
    {
      "familyId": 100,
      "campers": [
        { "camperName": "JJC1", "camperAge": 7, "enrolledSessions": "Week 1, Week 2" },
        { "camperName": "JJC2", "camperAge": 10, "enrolledSessions": "Week 2, Week 3" },
        { "camperName": "JJC3", "camperAge": 12, "enrolledSessions": "Week 5" }
      ],
      "parents": [
        {
          "rowNum": 1,
          "leadName": "John",
          "leadEmail": "john@test.com"
        },
        {
          "rowNum": 2,
          "leadName": "Jill",
          "leadEmail": "jill@test.com"
        }
      ]
    },
    {
      "familyId": 101,
      "campers": [
        { "camperName": "AAC1", "camperAge": 8, "enrolledSessions": "Week X" },
        { "camperName": "AAC2", "camperAge": 10, "enrolledSessions": "Week Y" }
      ],
      "parents": [
        {
          "rowNum": 4,
          "leadName": "Andy",
          "leadEmail": "andy@test.com"
        },
        {
          "rowNum": 5,
          "leadName": "Angela",
          "leadEmail": "angela@test.com"
        }
      ]
    }
  ]
}

export const AfterFanoutTransformationExampleRows = {
  "rows": [
    {
      "familyId": 100,
      "campers": [
        { "camperName": "JJC1", "camperAge": 7, "enrolledSessions": "Week 1, Week 2" },
        { "camperName": "JJC2", "camperAge": 10, "enrolledSessions": "Week 2, Week 3" },
        { "camperName": "JJC3", "camperAge": 12, "enrolledSessions": "Week 5" }
      ],
      "rowNum": 1,
      "leadName": "John",
      "leadEmail": "john@test.com"
    },
    {
      "familyId": 100,
      "campers": [
        { "camperName": "JJC1", "camperAge": 7, "enrolledSessions": "Week 1, Week 2" },
        { "camperName": "JJC2", "camperAge": 10, "enrolledSessions": "Week 2, Week 3" },
        { "camperName": "JJC3", "camperAge": 12, "enrolledSessions": "Week 5" }
      ],
      "rowNum": 2,
      "leadName": "Jill",
      "leadEmail": "jill@test.com"
    },
    {
      "familyId": 101,
      "campers": [
        { "camperName": "AAC1", "camperAge": 8, "enrolledSessions": "Week X" },
        { "camperName": "AAC2", "camperAge": 10, "enrolledSessions": "Week Y" }
      ],
      "rowNum": 4,
      "leadName": "Andy",
      "leadEmail": "andy@test.com"
    },
    {
      "familyId": 101,
      "campers": [
        { "camperName": "AAC1", "camperAge": 8, "enrolledSessions": "Week X" },
        { "camperName": "AAC2", "camperAge": 10, "enrolledSessions": "Week Y" }
      ],
      "rowNum": 5,
      "leadName": "Angela",
      "leadEmail": "angela@test.com"
    }
  ]
}

export const AfterFlattenTransformationExampleRows = {
  "rows": [
    {
      "familyId": 100,
      "camper1Name": "JJC1",
      "camper1Age": 7,
      "camper1EnrolledSessions": "Week 1, Week 2",
      "camper2Name": "JJC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week 2, Week 3",
      "camper3Name": "JJC3",
      "camper3Age": 12,
      "camper3EnrolledSessions": "Week 5",
      "rowNum": 1,
      "leadName": "John",
      "leadEmail": "john@test.com"
    },
    {
      "familyId": 100,
      "camper1Name": "JJC1",
      "camper1Age": 7,
      "camper1EnrolledSessions": "Week 1, Week 2",
      "camper2Name": "JJC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week 2, Week 3",
      "camper3Name": "JJC3",
      "camper3Age": 12,
      "camper3EnrolledSessions": "Week 5",
      "rowNum": 2,
      "leadName": "Jill",
      "leadEmail": "jill@test.com"
    },
    {
      "familyId": 101,
      "camper1Name": "AAC1",
      "camper1Age": 8,
      "camper1EnrolledSessions": "Week X",
      "camper2Name": "AAC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week Y",
      "rowNum": 4,
      "leadName": "Andy",
      "leadEmail": "andy@test.com"
    },
    {
      "familyId": 101,
      "camper1Name": "AAC1",
      "camper1Age": 8,
      "camper1EnrolledSessions": "Week X",
      "camper2Name": "AAC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week Y",
      "rowNum": 5,
      "leadName": "Angela",
      "leadEmail": "angela@test.com"
    }
  ]
}

export const AfterAddNewFieldsTransformationExampleRows = {
  "rows": [
    {
      "familyId": 100,
      "camper1Name": "JJC1",
      "camper1Age": 7,
      "camper1EnrolledSessions": "Week 1, Week 2",
      "camper2Name": "JJC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week 2, Week 3",
      "camper3Name": "JJC3",
      "camper3Age": 12,
      "camper3EnrolledSessions": "Week 5",
      "rowNum": 1,
      "leadName": "John",
      "leadEmail": "john@test.com",
      "familyEnrolledSessions": "Week 1, Week 2, Week 3, Week 5"
    },
    {
      "familyId": 100,
      "camper1Name": "JJC1",
      "camper1Age": 7,
      "camper1EnrolledSessions": "Week 1, Week 2",
      "camper2Name": "JJC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week 2, Week 3",
      "camper3Name": "JJC3",
      "camper3Age": 12,
      "camper3EnrolledSessions": "Week 5",
      "rowNum": 2,
      "leadName": "Jill",
      "leadEmail": "jill@test.com",
      "familyEnrolledSessions": "Week 1, Week 2, Week 3, Week 5"
    },
    {
      "familyId": 101,
      "camper1Name": "AAC1",
      "camper1Age": 8,
      "camper1EnrolledSessions": "Week X",
      "camper2Name": "AAC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week Y",
      "rowNum": 4,
      "leadName": "Andy",
      "leadEmail": "andy@test.com",
      "familyEnrolledSessions": "Week X, Week Y"
    },
    {
      "familyId": 101,
      "camper1Name": "AAC1",
      "camper1Age": 8,
      "camper1EnrolledSessions": "Week X",
      "camper2Name": "AAC2",
      "camper2Age": 10,
      "camper2EnrolledSessions": "Week Y",
      "rowNum": 5,
      "leadName": "Angela",
      "leadEmail": "angela@test.com",
      "familyEnrolledSessions": "Week X, Week Y"
    }
  ]
}

